import { DisableBranchRepository } from '../../domain/repositories/DisableBranchRepository'
import { DisableBranchModel } from '../models/DisableBranchModel'
import { DisableBranchReasonsService, type DisableBranchReasonListedAdminDto, type PostDisableBranchReasonRequestAdmin, type PutDisableBranchReasonRequestAdmin } from '@/backend/market'
import { DisableBranchMiniModel } from '../models/DisableBranchMiniModel'
import type { DisableBranchMiniEntity } from '../../domain/entities/DisableBranchMiniEntity'
import type { DisableBranchEntity } from '../../domain/entities/DisableBranchEntity'
import type { CreateUpdateDisableBranchEntity } from '../../domain/entities/CreateUpdateDisableBranchEntity'
import { CreateUpdateDisableBranchModel } from '../models/CreateUpdateDisableBranchModel'

export class DisableBranchRepositoryImpl implements DisableBranchRepository {
 

  async getDisableBranch(): Promise<DisableBranchMiniEntity[] | "error"> {
    try { 
      const response = await DisableBranchReasonsService.getDisableBranchReasonsAsyncAdmin()
      return response.map((item: DisableBranchReasonListedAdminDto) => new DisableBranchMiniModel(item))
    } catch {
      return "error"
    }
  }

  async getDisableBranchReasonById(id: number): Promise<DisableBranchEntity | { error: true }> {
    try {
      const response = await DisableBranchReasonsService.getDisableBranchReasonByIdAsyncAdmin({
        id
      })
      const disableBranchModel = new DisableBranchModel(response)
      return disableBranchModel
    } catch {
      return { error: true }
    }
  }

  async createDisableBranchReason(
    data: CreateUpdateDisableBranchEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateBranchTranslationModel = new CreateUpdateDisableBranchModel(data)
    try {
      
      await DisableBranchReasonsService.createDisableBranchReasonAsyncAdmin({
        requestBody: createUpdateBranchTranslationModel as PostDisableBranchReasonRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateDisableBranchReason(
    id: number,
    data: CreateUpdateDisableBranchEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateBranchTranslationModel = new CreateUpdateDisableBranchModel(data)
    try {
      await DisableBranchReasonsService.updateDisableBranchReasonAsyncAdmin({
        id,
        requestBody: createUpdateBranchTranslationModel as PutDisableBranchReasonRequestAdmin
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteDisableBranchReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await DisableBranchReasonsService.deleteDisableBranchReasonAsyncAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
